export default __webpack_public_path__ + "assets/aboutus.b985ab.jpg";